module.exports = __webpack_public_path__ + "static/media/6thSlide.82b22d2f.mp3";